export const setCurrent = (element, current = true) => {
  if (!element) {
    return;
  }
  const classToDelete = current ? 'nocurrent' : 'current';
  const classToAdd = current ? 'current' : 'nocurrent';
  element.classList.remove(classToDelete);
  element.classList.add(classToAdd);
};